import React, { useContext, useState } from "react";
import {
  StyledMainContainer,
  StyledStatsCard,
  StyledRecompensaCard,
  StyledMainContainerLanding,
  StyledBeneficioCard,
  StyledAlfabetizacionSection,
  StyledImageCard,
  StyledBlogButton,
  StyledHeroSection,
  PrincipalContainerHome,
} from "./styled";
import { Typography, Grid, Button } from "@mui/material";
import { colors } from "../../theme/colors";

import ben1 from "../../img/home-recompensas.png";
import ben2 from "../../img/home-retos-nuevospng.png";
import ben3 from "../../img/home-usuarios.png";
import ben4 from "../../img/home-numero.png";
import ben5 from "../../img/home-elige-tu-ritmo.png";

import imgIzquierda from "../../img/home-glosario-inanciero.png";
import imgDerecha from "../../img/home-test-bienestar-financiero.png";
import imgCentral from "../../img/home-libertad-financiera.png";
import appScreen from "../../img/gana-recompensas-bi-home.png";

import { AuthContext } from "../../context/authContext";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import CarouselFinanciero from "../../components/common/Carrousel/index";

import AnimatedText from "../../components/common/AnimatedText/index";
import { useNavigate } from "react-router-dom";

export default function AlfabetizacionFinanciera() {
  const { idCliente, logout } = useContext(AuthContext);
  const isLoggedIn = !!idCliente;
  const navigate = useNavigate();

  const beneficios = [
    {
      title: "12 recompensas anuales",
      desc: "Cada mes puedes obtener recompensas al completar tus desafíos financieros. ¡12 oportunidades al año para celebrar tu progreso!",
      img: ben1,
    },
    {
      title: "Retos nuevos todos los meses",
      desc: "Cada mes lanzamos desafíos prácticos que te ayudan a mejorar tus hábitos financieros de forma dinámica y entretenida.",
      img: ben2,
    },
    {
      title: "Más de 20K Usuarios",
      desc: "Miles de personas ya están mejorando sus finanzas con nosotros. Sé parte de una red que aprende y se apoya mutuamente.",
      img: ben3,
    },
    {
      title: "Más de 5 Retos por mes",
      desc: "Disfruta de una variedad de retos adaptados a tus necesidades: ahorro, presupuesto, pagos y más. Siempre hay algo nuevo por descubrir.",
      img: ben4,
    },
    {
      title: "Elige tu ritmo, alcanza tus metas",
      desc: "Con múltiples retos disponibles cada mes, tienes el control de tu aprendizaje financiero.",
      img: ben5,
    },
  ];

  return (
    <div style={{ width: "100%", backgroundColor: "#fff" }}>
      {!isLoggedIn && <Header />}
      <PrincipalContainerHome>
        <Grid container spacing={3} alignItems="center">
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: { xs: "2rem", md: "0rem" },
              marginBottom: { xs: "2rem", md: "0rem" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: colors.primary,
                fontSize: { xs: "20px", md: "38px" },
                marginBottom: "1rem",
              }}
            >
              Gana premios
            </Typography>
            <Typography>
              <AnimatedText />
            </Typography>
            <Typography sx={{ color: colors.secondary, marginTop: "1rem" }}>
              Y completa los
            </Typography>
            <Typography sx={{ color: colors.secondary, marginTop: "1rem" }}>
              <strong>Retos Banco Industrial</strong>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: colors.secondary,
              paddingRight: "3rem !important",
              paddingLeft: "4rem !important",
              paddingTop: "4rem !important",
            }}
          >
            <img
              src={appScreen}
              alt="App BI"
              style={{ width: "90%", borderRadius: "16px" }}
            />
          </Grid>
        </Grid>
      </PrincipalContainerHome>

      <StyledMainContainerLanding white>
        <CarouselFinanciero />
      </StyledMainContainerLanding>

      <StyledMainContainerLanding white>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{ marginTop: "2rem" }}
        >
          {beneficios.map((item, idx) => (
            <Grid item xs={6} sm={6} md={4} lg={2.4} key={idx}>
              <StyledBeneficioCard>
                <div className="image-container">
                  <img src={item.img} alt={item.title} />
                </div>
                <div className="content-container">
                  <Typography variant="h6" className="benefit-title">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" className="benefit-description">
                    {item.desc}
                  </Typography>
                </div>
              </StyledBeneficioCard>
            </Grid>
          ))}
        </Grid>
      </StyledMainContainerLanding>

      <StyledAlfabetizacionSection>
        <Typography variant="h6" className="section-title">
          Alfabetización Financiera
        </Typography>

        <div className="images-container">
          <StyledImageCard className="side-image">
            <img src={imgIzquierda} alt="Notificación" />
            <div className="image-text">Glosario Financiero</div>
          </StyledImageCard>

          <StyledImageCard className="center-image">
            <img src={imgCentral} alt="Central" />
            <div className="image-text">Aprende y Gana</div>
          </StyledImageCard>

          <StyledImageCard className="side-image">
            <img src={imgDerecha} alt="Celebrando" />
            <div className="image-text">Reclama Premios</div>
          </StyledImageCard>
        </div>

        <Typography className="blog-info">
          Sigue aprendiendo en nuestro Blog
        </Typography>

        <StyledBlogButton id="Btn-click-blogs-retos">
          Ir al Blog
        </StyledBlogButton>
      </StyledAlfabetizacionSection>

      {!isLoggedIn && <Footer />}
    </div>
  );
}
